export var DeepLinkModule;
(function (DeepLinkModule) {
    DeepLinkModule["COBRANCAS"] = "cobrancas";
    DeepLinkModule["BENEFICIOS"] = "beneficios";
})(DeepLinkModule || (DeepLinkModule = {}));
